import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RiskBoardService {
  private baseUrl = environment.WS_URL + '/api/v1';

  constructor(private http: HttpClient) { }

  getMonths(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/coffee/risk-board/futures/');
  }
}
